import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation DeleteTenant($deleteTenantId: ID!) {
    deleteTenant(id: $deleteTenantId) {
      id
    }
  }
`
const TRANSFORMER = graphql.transformers.OUT.always(undefined)

export const executor = graphql.createExecutor<
  graphql.schema.DeleteTenantMutation,
  void,
  graphql.schema.DeleteTenantMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
